/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const c = (...s) => Object.assign({ allowUnsort: !0, mode: "single" }, ...s), e = {
  true: {
    asc: { asc: "", desc: "desc" },
    desc: { asc: "asc", desc: "" },
    "": { asc: "asc", desc: "desc" }
  },
  false: {
    asc: { asc: "asc", desc: "desc" },
    desc: { asc: "asc", desc: "desc" },
    "": { asc: "asc", desc: "desc" }
  }
}, a = {
  true: { asc: "desc", desc: "", "": "asc" },
  false: { asc: "desc", desc: "asc", "": "asc" }
};
export {
  a as firstLevelSortSeqMap,
  c as normalizeSortable,
  e as sortSeqMap
};
